import { Col, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { Latestarticles } from "../../../Constant";
import { ArticeVideo1 } from "./ArticeVideo1";
import ArticeVideo2 from "./ArticeVideo2";
import ArticeVideo3 from "./ArticeVideo3";

const ArticeVideo = () => {
  return (
    <Col lg="12">
      <div className="header-faq">
        <H3 className="mb-0">{Latestarticles}</H3>
      </div>
      <Row>
        <ArticeVideo1 />
        <ArticeVideo2 />
        <ArticeVideo3 />
      </Row>
    </Col>
  );
};
export default ArticeVideo;
